import { FLOW_TYPE } from 'models/FlowModel';

/**
 * sessionStorage flag for rendezvous "sign-in only" mode (legacy and terra nova agnostic rendezvous flows).
 * When set to AGNOSTIC_RENDEZVOUS_SIGN_IN_ONLY, hides the sign-up link and some partner CTAs on sign-in on legacy pages.
 */
const ACTIVATION_SCREEN_STORAGE_KEY = 'overrideFlowType';

/**
 * localStorage flag for provider flow (agnostic rendezvous flow with entrypoint /provider/ and after code lookup step /partner/)
 */
const PROVIDER_FLOW_STORAGE_KEY = 'partnerUrl';

/**
 * localStorage payload from Terra Nova rendezvous; read on tn-rendezvous to hydrate FlowStore
 * (activationCode, deviceName, devicePartner, activationScreen).
 */
const TERRANOVA_RENDEZVOUS_LOCAL_STORAGE_KEY = 'rendezvousContext';

export default class RendezvousContext {
    static clearStoredActivationScreen() {
        if (sessionStorage.getItem(ACTIVATION_SCREEN_STORAGE_KEY)) {
            sessionStorage.removeItem(ACTIVATION_SCREEN_STORAGE_KEY);
        }
    }

    static clearStoredProviderFlow() {
        localStorage.removeItem(PROVIDER_FLOW_STORAGE_KEY);
    }

    static getTerraNovaRendezvousContext() {
        try {
            const savedContext = JSON.parse(
                localStorage.getItem(TERRANOVA_RENDEZVOUS_LOCAL_STORAGE_KEY) || '{}',
            );

            if (savedContext && typeof savedContext === 'object') {
                return savedContext;
            }
        } catch (e) {}

        return {};
    }

    static isActivationScreenSignIn() {
        return (
            sessionStorage.getItem(ACTIVATION_SCREEN_STORAGE_KEY) ===
            FLOW_TYPE.AGNOSTIC_RENDEZVOUS_SIGN_IN_ONLY
        );
    }

    static isProviderFlow() {
        return localStorage.getItem(PROVIDER_FLOW_STORAGE_KEY) === 'true';
    }

    static storeActivationScreenSignIn() {
        sessionStorage.setItem(
            ACTIVATION_SCREEN_STORAGE_KEY,
            FLOW_TYPE.AGNOSTIC_RENDEZVOUS_SIGN_IN_ONLY,
        );
    }

    static storeProviderFlow() {
        localStorage.setItem(PROVIDER_FLOW_STORAGE_KEY, 'true');
    }
}
